import React, { useEffect, useState } from 'react';
import { Container } from 'react-bootstrap';
import { useNavigate, useParams } from 'react-router-dom';
import { useTheme } from '../../contexts/ThemeContext';
import LoadAddForm from '../../components/Forms/load-add-form';
import loadService from '../../services/loadService';
import Loading from '../../components/loading-animation';

const LoadsEditPage = () => {
  const { getThemeColors } = useTheme();
  const colors = getThemeColors();
  const navigate = useNavigate();
  const { id } = useParams();
  const [loadData, setLoadData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchLoadData = async () => {
      try {
        setLoading(true);
        const response = await loadService.getLoadById(id);
        const load = response?.data?.data || response?.data || response;
        setLoadData(load);
      } catch (err) {
        setError(err?.response?.data?.message || err?.message || 'Failed to load load data');
      } finally {
        setLoading(false);
      }
    };

    if (id) {
      fetchLoadData();
    }
  }, [id]);

  const handleClose = () => {
    navigate('/loads');
  };

  const handleSuccess = (updatedLoad) => {
    navigate('/loads');
  };

  if (loading) {
    return (
      <Container fluid style={{ backgroundColor: colors.background, minHeight: '100vh' }}>
        <Loading size="large" />
      </Container>
    );
  }

  if (error) {
    return (
      <Container fluid style={{ backgroundColor: colors.background, minHeight: '100vh' }}>
        <div style={{ padding: '24px', textAlign: 'center', color: 'red' }}>
          {error}
        </div>
      </Container>
    );
  }

  return (
    <Container fluid style={{ backgroundColor: colors.background, minHeight: '100vh' }}>
      <div style={{ padding: '24px' }}>
        <LoadAddForm
          loadId={id}
          loadData={loadData}
          onClose={handleClose}
          onSuccess={handleSuccess}
          isEditMode={true}
        />
      </div>
    </Container>
  );
};

export default LoadsEditPage;


